import { useEffect, useCallback, useState, useMemo } from 'react';
import { ShellEvent } from '@appd/fso-ui-shell/container';
import { ShellEventType } from '../modules/contracts/fso-shell/fsoShellConstants';
import { TimeRangeSelector } from '@appd/uik/@future';

export type TimeRange = TimeRangeSelector.TimeRange.Resolved;

export const useShellEvents = (initialTimeRange: TimeRange) => {
  const [timeRange, setTimeRange] = useState<TimeRange>(initialTimeRange);

  const hasTimeRangeChanged = (oldTimeRange: TimeRange, newTimeRange: TimeRange) =>
    oldTimeRange.since !== newTimeRange.since || oldTimeRange.until !== newTimeRange.until;

  const handleTimeRange = useCallback(
    ({ value }: TimeRangeSelector.TimeRange.Event) => {
      const newTimeRange = TimeRangeSelector.TimeRange.resolve(value);
      if (hasTimeRangeChanged(timeRange, newTimeRange)) {
        setTimeRange(newTimeRange);
      }
    },
    [timeRange],
  );

  useEffect(() => {
    ShellEvent.on(ShellEventType.TimeRangeChanged, handleTimeRange);

    return () => {
      ShellEvent.un(ShellEventType.TimeRangeChanged, handleTimeRange);
    };
  }, [handleTimeRange]);

  const memoizedReturnObj = useMemo(() => {
    return { timeRange, handleTimeRange };
  }, [timeRange, handleTimeRange]);

  return memoizedReturnObj;
};
